import useClientSaveStatus from './useClientSaveStatus'
import { StatusText } from './styled-components'

const ClientSaveStatus = () => {
  const { statusText, hasUnsavedChanges } = useClientSaveStatus()

  return (
    <StatusText $warning={hasUnsavedChanges} role='status'>
      {statusText}
    </StatusText>
  )
}

export default ClientSaveStatus
